import * as React from "react";
import gql from 'graphql-tag';
import { client } from "src";

export class QueryFilter extends React.Component<any, any> {

  public static updateState(){

      client.query({ query: QUERY_FILTER_UPDATE_PUBLISHER });
  }

  public static updateMutationPublisher(){
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterPublisher','publisherEconomicGroupFilter','publisherPublisherFilter'
    ,'publisherStampFilter', 'publisherBookstoreFilter', 'publisherUfFilter'
    , 'publisherBookFilter'
    , 'publisherRevenue30Days', 'publisherMonthComparative', 'publisherMarketShare',
    'publisherRegionShare', 'publisherSubjectShare', 'publisherStoreMarketShare', 'publisherStoreShare', 'publisherEconomicGroupShare'
    , 'publisherAnalysisData', 'publisherCountAnalysis', 'publisherAnalysisSubTotalsData', 'publisherSkuSold'
    , 'publisherSalesCurrentYear', 'publisherSalesLastYears', 'publisherCategoryPnShare', 'publisherCategoryBisacShare'
    , 'publisherWeeklyEvolution', 'publisherWeeklyEvolutionBookstore'
  ]
    });
  }

  public static updateMutationBookstore(){
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterBookstore','bookstoreAveragePrice', 'bookstoreAveragePriceThirtyDays','bookstoreAverageTicket'
      ,'bookstoreCategoryShare','bookstoreCoupon','bookstoreCouponItem',
      'bookstoreMonthComparative' ,'bookstoreRegionShare','bookstoreRevenue30Days',
      'bookstoreCategoryFilter','bookstoreProductFilter','bookstoreProviderFilter','bookstoreStoreFilter',
       'bookstoreStoreShare', 'bookstoreSubjectShare', 'bookstoreSubjectShare',
      'bookstoreUfFilter', 'bookstoreSalesForHour', 'bookstoreAnalysisData'
      , 'bookstoreSalesCurrentYear'
      ]
    });
  }

  public static updateMutationBestselling() {
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterBestselling','generalSalesPanel','vejaPanel','publishNewsPanel']
    });
  }

  public static updateMutationMarket () {
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterMarket', 'marketPublisherCompareBilling', 'marketPublisherCompareProducts', 'marketPublisherCompareVolume',
        'marketPublishersLastMonths', 'marketSharePublishers', 'marketShareRankingPublishers', 'marketProviderFilter', 'marketCategoryFilter',
        'marketCompareBillingMarket', 'marketCompareProductsMarket', 'marketCompareVolumeMarket', 
        'marketPriceAveragePrice', 'marketPriceAverageTicket', 'marketPriceAverageTicketEvolution', 'marketPriceCoupon', 'marketPriceCoverPrice',
        'marketCategoriesLastMonths']
    });
  }

  public static updateMutationMarketBookstore () {
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterMarketBookstore', 'marketShareBookstoreShareBilling', 'marketShareBookstoreShareBillingMarket', 'marketShareBookstoreShareRanking', 
        'marketCategoryBookstoreSalesByTheme', 'marketCategoryBookstoreQtdProdsByCategory' , 'marketCategoryBookstoreSalesEvolutionByCategory', 'marketCategoryBookstoreSalesByCategory', 
        'marketCategoryBookstoreCategoryAnalytical', 'marketCategoryBookstoreCategoryAnalyticalSubTotalsData', 'marketCategoryBookstoreCategoryAnalyticalFindQtdProducts',
        'marketCategoryBookstoreRanking', 'marketShareBookstoreShareAverageTicketEvolution', 'marketShareBookstoreBillingEvolutionByMonth',
        'marketCategoryBookstoreSalesCategoryPN']
    });
  }

  public static updateMutationAnalyticsFilter () {
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryAnalyticsFilter','analyticsGroupFilter', 'analyticsProviderFilter', 'analyticsUsersFilter']
    });
  }

  public static updateMutationConsultingPublisherFilter () {
    client.mutate({
      mutation: MUTATION_FILTER,
      refetchQueries: ['queryFilterConsultingPublisher', 'consultingPublisherSalesEvolution']
    });
  }

   public static getFilterPublisher(clientApollo: any, filterComponent: any, filter: string[]): any {
      filterComponent = this.getFilterPublisherCore(clientApollo, filterComponent, filter);

      if(clientApollo.cache.data.data.ROOT_QUERY && clientApollo.cache.data.data.ROOT_QUERY.FILTER_endDateFilterChecked) {
        filterComponent.customFilter.endDate  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_endDateFilterChecked;
      }

      if(clientApollo.cache.data.data.ROOT_QUERY && clientApollo.cache.data.data.ROOT_QUERY.FILTER_initialDateFilterChecked) {
        filterComponent.customFilter.initialDate  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_initialDateFilterChecked;
      }

      if(filter !== undefined && filter.length > 0){
        for (const item of filter) {
          delete filterComponent.customFilter[item];
        }
      }

    return filterComponent;
  }

  public static getFilterPublisherByChip(clientApollo: any, filterComponent: any, filter: string[]): any {
    return this.getFilterPublisherCore(clientApollo, filterComponent, filter);
  }

  public static getFilterBookstore(clientApollo: any, filterComponent: any, filter: string[]): any {
    filterComponent = this.getFilterBookstoreCore(clientApollo, filterComponent, filter);

    if(clientApollo.cache.data.data.ROOT_QUERY && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreEndDateFilterChecked
      && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreEndDateFilterChecked !== "") {
      filterComponent.customFilter.endDate  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreEndDateFilterChecked;
    }

    if(clientApollo.cache.data.data.ROOT_QUERY && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreInitialDateFilterChecked
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreInitialDateFilterChecked !== "") {
      filterComponent.customFilter.initialDate  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreInitialDateFilterChecked;
    }

    if(filter !== undefined && filter.length > 0){
      for (const item of filter) {
        delete filterComponent.customFilter[item];
      }
    }

  return filterComponent;
}

public static getFilterBookstoreByChip(clientApollo: any, filterComponent: any, filter: string[]): any {
  return this.getFilterBookstoreCore(clientApollo, filterComponent, filter);
}

public static getFilterBestselling(clientApollo: any, filterComponent: any, filter: string[], isFromChip: boolean): any {

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProviderFilterChecked != null 
      && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProviderFilterChecked !== undefined) {
        filterComponent.customFilter.provider = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProviderFilterChecked.json;
  }
  
  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProductFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProductFilterChecked !== undefined) {
      filterComponent.customFilter.product = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingProductFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacFilterChecked !== undefined) {
      filterComponent.customFilter.bisac = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingAuthorFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingAuthorFilterChecked !== undefined) {
      filterComponent.customFilter.author = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingAuthorFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacCodeFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacCodeFilterChecked !== undefined) {
      filterComponent.customFilter.bisac_code = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bestsellingBisacCodeFilterChecked.json;
  }
  
  
  if(!isFromChip) {
    if(filter !== undefined && filter.length > 0){
      for (const item of filter) {
        delete filterComponent.customFilter[item];
      }
    }
  }
  return filterComponent;
}

public static getFilterMarket(clientApollo: any, filterComponent: any, filter: string[], isFromChip: boolean): any {
    if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketCategoryFilterChecked != null 
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketCategoryFilterChecked !== undefined) {
        filterComponent.customFilter.category = clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketCategoryFilterChecked.json;
    }


    if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketProviderFilterChecked != null 
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketProviderFilterChecked !== undefined) {
        filterComponent.customFilter.provider = clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketProviderFilterChecked.json;
    }

    if(!filter.includes('stamp') && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterChecked != null 
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterChecked !== undefined) {

          filterComponent.customFilter.stamp = clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterChecked.json;


          if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterCheckedObj != null 
            && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterCheckedObj !== undefined
            && filterComponent.customFilter.provider != null 
            && filterComponent.customFilter.provider !== undefined) {

                const key = clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketStampFilterCheckedObj.id;
                if(clientApollo.cache.data.data[key]){
                  const arrayIds : any[] = [... clientApollo.cache.data.data[key].marketStampFilterCheckedObj];
                
                  const marketStampArray : any[] = [];
                  arrayIds.map((item:any) => {
                      marketStampArray.push(clientApollo.cache.data.data[item.id]);
                  });

                  const newMarketStampFilterCheckedObj : any[] = [];
                  const itensToRemove = marketStampArray.map( (item:any) => {
                      if(item!=null && item !== undefined) {
                        if(!filterComponent.customFilter.provider.includes(item.id.toString()) 
                          && (item.providerFatherId != null && item.providerFatherId !== undefined 
                          && !filterComponent.customFilter.provider.includes(item.providerFatherId.toString())) ) {
                            return item.id.toString();
                        } else {
                          newMarketStampFilterCheckedObj.push(item);
                        }
                      }
                  });
    
                  filterComponent.customFilter.stamp = filterComponent.customFilter.stamp.filter( (stamp:string) => !itensToRemove.includes(stamp));
                  client.writeData({ data: { marketStampFilterChecked: filterComponent.customFilter.stamp } });
                  client.writeData({ data: { FILTER_marketStampFilterChecked: filterComponent.customFilter.stamp } });
                  client.writeData({ data: { FILTER_marketStampFilterCheckedObj: {'marketStampFilterCheckedObj':newMarketStampFilterCheckedObj, '__typename':  'marketStampFilterCheckedObj'} } });
                }
          }
    }

    if(!isFromChip) {
      if(filter !== undefined && filter.length > 0){
        for (const item of filter) {
          delete filterComponent.customFilter[item];
        }
      }
    }

    return filterComponent;
}

public static getFilterMarketBookstore (clientApollo: any, filterComponent: any, filter: string[], isFromChip: boolean): any {
  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketBookstoreStoreFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketBookstoreStoreFilterChecked !== undefined) {
    filterComponent.customFilter.store = clientApollo.cache.data.data.ROOT_QUERY.FILTER_marketBookstoreStoreFilterChecked.json;
  }

  if(!isFromChip) {
    if(filter !== undefined && filter.length > 0){
      for (const item of filter) {
        delete filterComponent.customFilter[item];
      }
    }
  }
  return filterComponent; 
}

public static getFilterAnalytics(clientApollo: any, filterComponent: any, filter: string[], isFromChip:boolean) {
  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsGroupFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsGroupFilterChecked !== undefined) {
    filterComponent.customFilter.groups = clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsGroupFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsProviderFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsProviderFilterChecked !== undefined) {
    filterComponent.customFilter.providers = clientApollo.cache.data.data.ROOT_QUERY.FILTER_analyticsProviderFilterChecked.json;
  }

  if(!isFromChip) {
    if(filter !== undefined && filter.length > 0){
      for (const item of filter) {
        delete filterComponent.customFilter[item];
      }
    }
  }
  return filterComponent;
}

public static getFilterConsultingPublisher(clientApollo: any, filterComponent: any, filter: string[], isFromChip:boolean): any {
  
  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked !== undefined) {
    filterComponent.customFilter.period = clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherProviderFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherProviderFilterChecked !== undefined) {
    filterComponent.customFilter.publishers = clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherProviderFilterChecked.json;
  }

  if(clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherBisacFilterChecked != null 
    && clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherBisacFilterChecked !== undefined) {
    filterComponent.customFilter.bisacs = clientApollo.cache.data.data.ROOT_QUERY.FILTER_consultingPublisherBisacFilterChecked.json;
  }

  if(!isFromChip) {
    if(filter !== undefined && filter.length > 0){
      for (const item of filter) {
        delete filterComponent.customFilter[item];
      }
    }
  }

  return filterComponent;
}

public static getBookstoreProductFilter (clientApollo: any) {
  return clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreProductFilterChecked.json;
}

public static getBookstoreUfFilter (clientApollo: any) {
  return clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreUfFilterChecked.json;
}

public static getBookstoreStoryFilter (clientApollo: any) {
  return clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreStoreFilterChecked.json;
}

public static getBookstoreCategoryFilter (clientApollo: any) {
  return clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreCategoryFilterChecked.json;
}

  private static getFilterPublisherCore (clientApollo: any, filterComponent: any, filter: string[]): any {
    filterComponent.customFilter.ufs  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherUfFilterChecked.json;
    filterComponent.customFilter.bookstores = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBookstoreFilterChecked.json;
    filterComponent.customFilter.groups = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherEconomicGroupFilterChecked.json;
    filterComponent.customFilter.stambs = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherStampFilterChecked.json;
    filterComponent.customFilter.books = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBookFilterChecked.json;
    filterComponent.customFilter.bisac = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBisacFilterChecked.json;
    filterComponent.customFilter.publishers = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherPublisherFilterChecked.json;
    filterComponent.customFilter.author = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherAuthorFilterChecked.json;
    filterComponent.customFilter.bisac_code = clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBisacCodeFilterChecked.json;

    return filterComponent;
  }

  private static getFilterBookstoreCore(clientApollo: any, filterComponent: any, filter: string[]): any {

    filterComponent.customFilter.ufs  = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreUfFilterChecked.json;
    filterComponent.customFilter.category = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreCategoryFilterChecked.json;
    filterComponent.customFilter.provider = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreProviderFilterChecked.json;
    filterComponent.customFilter.store = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreStoreFilterChecked.json;
    filterComponent.customFilter.product = clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreProductFilterChecked.json;
  
    return filterComponent;
  }

  constructor(props: any){
      super(props);

  }

}

export const QUERY_FILTER_PUBLISHER = gql`
query queryFilterPublisher {
  publisherBookFilterChecked @client
  publisherBookstoreFilterChecked @client
  publisherEconomicGroupFilterChecked @client
  publisherPublisherFilterChecked @client
  publisherStampFilterChecked @client
  publisherUfFilterChecked @client
  publisherBisacFilterChecked @client
  publisherAuthorFilterChecked @client
  publisherBisacCodeFilterChecked @client
}
`;
// TODO COLOCAR OS FILTROS CORRETOS
export const QUERY_FILTER_BOOKSTORE = gql`
query queryFilterBookstore {
    bookstoreCategoryFilterChecked @client
    bookstoreProductFilterChecked @client
    bookstoreProviderFilterChecked @client
    bookstoreStoreFilterChecked @client
    bookstoreUfFilterChecked @client
}
`;

export const QUERY_FILTER_BESTSELLING = gql`
query queryFilterBestselling {
    bestsellingProductFilterChecked @client
    bestsellingProviderFilterChecked @client
    bestsellingBisacFilterChecked @client
    bestsellingAuthorFilterChecked @client
    bestsellingBisacCodeFilterChecked @client
}
`;

export const QUERY_FILTER_MARKET = gql`
query queryFilterMarket {
  marketCategoryFilterChecked @client
  marketProviderFilterChecked @client
  marketStampFilterChecked @client
  # marketEconomicGroupFilterChecked @client
  # marketUfFilterChecked @client
  # marketStoreFilterChecked @client
}
`;

export const QUERY_FILTER_CONSULTING_PUBLISHER = gql`
query queryFilterConsultingPublisher {
  consultingPublisherPeriodFilterChecked @client
  consultingPublisherProviderFilterChecked @client
  consultingPublisherBisacFilterChecked @client
}
`;

export const QUERY_FILTER_MARKET_BOOKSTORE = gql`
query queryFilterMarketBookstore {
  marketBookstoreStoreFilterChecked @client
}
`;

export const QUERY_FILTER_ANALYTICS = gql`
  query queryAnalyticsFilter {
    analyticsGroupFilterChecked @client
    analyticsProviderFilterChecked @client
  }
`;

export const QUERY_FILTER_UPDATE_BOOKSTORE = gql`
    query queryFilterUpdateBookstore {
      FILTER_bookstoreCategoryFilterChecked
      FILTER_bookstoreProductFilterChecked
      FILTER_bookstoreProviderFilterChecked
      FILTER_bookstoreStoreFilterChecked
      FILTER_bookstoreUfFilterChecked
    }
    `;
export const QUERY_FILTER_UPDATE_PUBLISHER = gql`
    query queryFilterUpdatePublisher {
      FILTER_publisherBookFilterChecked
      FILTER_publisherBookstoreFilterChecked
      FILTER_publisherEconomicGroupFilterChecked
      FILTER_publisherPublisherFilterChecked
      FILTER_publisherStampFilterChecked
      FILTER_publisherUfFilterChecked
      FILTER_publisherBisacFilterChecked
      FILTER_publisherAuthorFilterChecked
      FILTER_publisherBisacCodeFilterChecked
    }
    `;
export const QUERY_FILTER_UPDATE_BESTSELLING = gql`
  query queryFilterUpdateBestselling {
    FILTER_bestsellingProductFilterChecked
    FILTER_bestsellingProviderFilterChecked
    FILTER_bestsellingBisacFilterChecked
    FILTER_bestsellingAuthorFilterChecked
    FILTER_bestsellingBisacCodeFilterChecked
  }
  `;

export const QUERY_FILTER_UPDATE_MARKET = gql`
  query queryFilterUpdateMarket {
    FILTER_marketProviderFilterChecked
    FILTER_marketCategoryFilterChecked
    FILTER_marketStampFilterChecked
  }
`;

export const QUERY_FILTER_UPDATE_MARKET_BOOKSTORE = gql`
  query queryFilterUpdateMarketBookstore {
    FILTER_marketBookstoreStoreFilterChecked
  }
`;

export const QUERY_FILTER_UPDATE_ANALYTICS = gql`
  query queryAnalyticsUpdateFilter {
    FILTER_analyticsGroupFilterChecked
    FILTER_analyticsProviderFilterChecked 
  }
`;

export const QUERY_FILTER_UPDATE_CONSULTING_PUBLISHER = gql`
  query queryConsultingPublisherUpdateFilter {
    FILTER_consultingPublisherPeriodFilterChecked
    FILTER_consultingPublisherProviderFilterChecked
    FILTER_consultingPublisherBisacFilterChecked
  }
`;

export const MUTATION_FILTER = gql`
mutation queryMutationFilter {
  publisherUfFilterChecked @client
  publisherBookstoreFilterChecked @client
  publisherEconomicGroupFilterChecked @client
}
`;



// WEBPACK FOOTER //
// ./src/component/shared/filter/QueryFilter.tsx